"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDistanceToBeach = function SvgDistanceToBeach(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.892.207a3.731 3.731 0 0 1 2.504 1.21c.802.882 2.043 2.327 3.15 3.956a2.621 2.621 0 0 1 0 2.949c-1.107 1.629-2.348 3.074-3.15 3.955a3.73 3.73 0 0 1-2.504 1.21c-.786.056-1.933.122-3.408.164v5.502h2.668a1.482 1.482 0 1 1 0 2.965h-8.3a1.482 1.482 0 0 1 0-2.965H9.52v-5.458h-.19c-3.033 0-5.261-.116-6.544-.206C1.77 13.417.846 12.768.56 11.72.272 10.657-.048 8.97.006 6.83c.051-2.039.333-3.66.58-4.716C.845 1.004 1.803.274 2.89.199A94.908 94.908 0 0 1 9.329 0c3.048 0 5.283.116 6.563.207Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDistanceToBeach);
var _default = exports["default"] = Memo;